<template>
  <div class="result-table">
    <UiTable :data="ss.state.result.list" :columns="columnDefs" class="ui-sortable-search-result-table">
      <template #header="{ col, colIndex, label }">
        <div class="search-result-table-header-inner">
          {{ label }}
          <SearchSorter
            class="is-hidden-mobile"
            v-if="col.sort"
            :ss="ss"
            :field="col.sort"
            :is-item="false"
          />
        </div>
      </template>
      <template #column-name="{ row }">
        <BaseLink :to="'/database/' + row.id">{{ ls(row.name) }}</BaseLink>
      </template>
      <template #column-description="{ row }">
        {{ ls(row.description) }}
      </template>
      <template #column-org="{ row }">
        <BaseLink :to="'/organization/' + row.permission.ownerOrg">
          <UiOrgSpan :id="row.permission.ownerOrg" />
        </BaseLink>
      </template>
      <template #column-fav="{ row }">
        <UiInteractPanel type="database" :data="row" />
      </template>
    </UiTable>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { ColumnDef } from '~/components/ui/UiTable.vue'

const { ls, lc, num, led } = useI18n()
const { isHina, isJps } = useServiceType()
const { $getCodeDbCategory } = useNuxtApp()

interface Props {
  ss: SearchStore<Database>
}
const props = withDefaults(defineProps<Props>(), {})

const dbCategoryCode: Code = $getCodeDbCategory()

const columnDefs: ColumnDef[] = [
  {
    label: () => ls({ ja: '名称', en: 'Name' }),
    path: ['name'],
    class: 'jps-srt-name',
    sort: 'name.yomi.sort',
    key: 'name',
  },
  isJps ? {
    label: () => ls({ ja: 'カテゴリ', en: 'Category' }),
    path: ['category'],
    class: 'jps-srt-cat',
    display: (c) => lc(dbCategoryCode, c),
  } : null,
  isHina ? {
    label: () => ls({ ja: '概要説明', en: 'Description' }),
    path: ['description'],
    class: 'jps-srt-org',
    key: 'description',
  } : null,
  {
    label: () => ls(dapLangGlobal.db.recordCount),
    path: ['recordCount'],
    class: 'jps-srt-count',
    sort: 'recordCount',
    display: (n) => num(n),
  },
  isJps ? {
    label: () => ls({ ja: '連携機関', en: 'Organization' }),
    class: 'jps-srt-org',
    key: 'org'
  } : null,
  isJps ? {
    label: () => ls({ ja: 'API', en: 'API' }),
    path: ['apiType'],
    display: (c: APIType) => {
      return led(A_P_I_TYPE_DEF, c)
    },
  } : null,
  {
    class: 'jps-srt-fav',
    key: 'fav',
  },
].filter(v => v)
</script>

<style lang="scss" scoped>
.ui-sortable-search-result-table {
  :deep(table) {
    width: 100%;
  }
}
</style>
